
// ============================================
// WhoWeAreDetailScene - 会社紹介詳細ページシーン
// ============================================

/**
 * GNS.WhoWeAreDetailScene
 * * メンバー詳細・会社紹介詳細ページのメイン制御クラス
 * APIから特定のIDに基づいた詳細データを取得し、ニュース一覧などを動的に生成する
 */
GNS.WhoWeAreDetailScene = function (GNS) {
    // AbstractSceneを継承
    const scene = GNS.create(GNS.AbstractScene);

    /**
     * 初期化処理
     */
    scene.init = function (data) {
        scene._super.init.call(this, data);

        this.detailId = null; // 旧 this.page
        this.buttons = [];    // 旧 this.playerArray

        // クラス名から詳細IDを抽出 (例: who_we_are_detail--12 -> 12)
        this._extractDetailId();

        // コンテンツ挿入用コンテナ
        this.container = new GNS.DisplayObject("who_we_are__insert");
    };

    /**
     * クラス名からIDを抽出するヘルパー
     */
    scene._extractDetailId = function () {
        const className = this.element.className || "";
        const match = className.match(/who_we_are_detail--(\d+)/);
        if (match && match[1]) {
            this.detailId = parseInt(match[1], 10);
        }
    };

    /**
     * ロード処理
     * IDがある場合はAPIリクエストを行う
     */
    scene.load = function () {
        if (this.detailId && this.detailId > 0) {
            GNS.APIWhoWeAre.dispatcher.addEventListener(GNS.Event.COMPLETE, this._onApiComplete);
            GNS.APIWhoWeAre.request(this.detailId);
        } else {
            this._onApiComplete(null);
        }
    };

    /**
     * APIデータロード完了後の処理
     */
    scene._bind._onApiComplete = function (event) {
        GNS.APIWhoWeAre.dispatcher.removeEventListener(GNS.Event.COMPLETE, this._onApiComplete);

        // HTML生成用コンテナ
        const wrapperDiv = document.createElement("div");
        let htmlContent = "";

        // データ解析
        const params = (event && event.params) ? event.params : {};
        const newsList = params.news || [];
        // const columnList = params.column || []; // 元コードでは変数はあったがHTML生成には使われていなかった

        // ニュースデータがある場合、HTMLを構築
        if (newsList.length > 0) {
            htmlContent += this._generateNewsSectionHtml(newsList);
        }

        // DOMへの挿入
        wrapperDiv.innerHTML = htmlContent;
        this.container.element.appendChild(wrapperDiv);
        this.addSceneEventIn(wrapperDiv); // フェードイン等の演出開始

        // インタラクティブ要素（ボタン等）のセットアップ
        this._initInteractiveElements();

        // 親クラスのロード完了処理
        scene._super.load.call(this);
    };

    /**
     * ニュースセクションのHTML生成
     * 3件ずつ1行にまとめて表示する構造
     */
    scene._generateNewsSectionHtml = function (newsList) {
        const imgPath = GNS.APIModel.IMAGE_PATH;
        let html = `
      <div class="who_we_are__news who_we_are__column">
        <h3 class="page__title">NEWS</h3>
        <div class="who_we_are__column__body">
    `;

        // 3件ごとのチャンク処理
        for (let i = 0; i < newsList.length; i += 3) {
            // 現在の行に表示する最大3件のデータ
            const chunk = newsList.slice(i, i + 3);

            html += '<div class="news__container__line">';

            // 1. 左側の矢印リンク群 (Arrow Links)
            html += '<div class="news__container__line__arror">';
            chunk.forEach(newsItem => {
                html += this._createArrowLinkHtml(newsItem, imgPath);
            });
            html += '</div>'; // close arrow container

            // 2. 右側の詳細ボックス群 (Content Boxes)
            chunk.forEach(newsItem => {
                html += this._createNewsBoxHtml(newsItem, imgPath);
            });

            html += '</div>'; // close line
        }

        html += `
        </div>
      </div>
    `;
        return html;
    };

    /**
     * 矢印リンク部分のHTML生成テンプレート
     */
    scene._createArrowLinkHtml = function (item, imgPath) {
        return `
      <div class="item__link">
        <a href="${item.url}">
          <div class="item__link__view">
            <div class="item__link__view__bartop"></div>
            <div class="item__link__view__barright"></div>
            <div class="item__link__view__barbottom"></div>
            <img class="item__link__view__img img_pc" src="${imgPath}common/link_arror_pc.png" />
            <img class="item__link__view__img img_sp" src="${imgPath}common/link_arror_sp.png" />
          </div>
          <div class="item__link__bg"></div>
        </a>
      </div>
    `;
    };

    /**
     * ニュース詳細ボックス部分のHTML生成テンプレート
     */
    scene._createNewsBoxHtml = function (item, imgPath) {
        return `
      <div class="news__container__line__box">
        <div class="news__container__line__box__column">
          <div class="news__container__line__box__column__img">
            <img src="${item.image}" />
          </div>
          <div class="news__container__line__box__column__text">
            <div class="news__container__line__box__column__text__date">
              <div class="news__container__line__box__column__text__date__tag">
                <p>${item.date}</p>
              </div>
              <div class="news__container__line__box__column__text__date__bar"></div>
            </div>
            <p class="news__container__line__box__column__text__title lang_jp">${item.title_jp}</p>
            <p class="news__container__line__box__column__text__title lang_en">${item.title_en}</p>
          </div>
        </div>
        <div class="news__container__line__box__overview lang_jp">${item.desc_jp}</div>
        <div class="news__container__line__box__overview lang_en">${item.desc_en}</div>
        
        <div class="item__link">
          <a href="${item.url}">
            <div class="item__link__view">
              <div class="item__link__view__bartop"></div>
              <div class="item__link__view__barright"></div>
              <div class="item__link__view__barbottom"></div>
              <img class="item__link__view__img img_pc" src="${imgPath}common/link_arror_pc.png" />
              <img class="item__link__view__img img_sp" src="${imgPath}common/link_arror_sp.png" />
            </div>
            <div class="item__link__bg"></div>
          </a>
        </div>
      </div>
    `;
    };

    /**
     * 生成されたDOMに対してインタラクション（ボタン化）を適用
     */
    scene._initInteractiveElements = function () {
        const columnBody = this.container.element.querySelector(".who_we_are__column__body");

        // 1. カラムリストアイテム（存在する場合）のボタン化
        // ※元のコードではHTML生成ロジックが見当たりませんでしたが、
        //  DOM要素が存在すれば機能するように実装されています。
        if (columnBody) {
            const colItems = columnBody.querySelectorAll(".column__container__list__item");
            Array.from(colItems).forEach((item, index) => {
                const imgEl = item.querySelector(".column__container__list__item__img img");
                const linkEl = item.querySelector(".item__link");

                const imgObj = imgEl ? new GNS.DisplayObject(imgEl) : null;
                const containerObj = new GNS.DisplayObject(item);

                const btn = new GNS.UIThumBtn(linkEl, null, imgObj, containerObj, null, 0.05 * index);
                this.buttons.push(btn);
            });
        }

        // 2. ニュースアイテムのボタン化（左側の矢印と、右側のボックスを連動させる）
        const arrowGroups = this.element.querySelectorAll(".news__container__line__arror");
        const newsBoxes = this.element.querySelectorAll(".news__container__line__box");

        if (arrowGroups.length > 0) {
            // 最初のグループから矢印リンクのリストを取得（全ニュース分フラットに処理）
            const arrowLinks = arrowGroups[0].querySelectorAll(".item__link");

            // 各ニュースボックスと矢印リンクを1対1で紐付ける
            Array.from(newsBoxes).forEach((box, index) => {
                // 対応する矢印リンク
                const arrowLinkEl = arrowLinks[index];

                // ボックス内の画像
                const boxImgEl = box.querySelector(".news__container__line__box__column__img img");
                const boxImgObj = boxImgEl ? new GNS.DisplayObject(boxImgEl) : null;

                // ボックス自体
                const boxObj = new GNS.DisplayObject(box);

                // ボックス内のリンク（「More」ボタンなど）
                const internalLinkObj = new GNS.DisplayObject(box.querySelector(".item__link"));

                // UIThumBtn(LinkElement, Bg, ImageObj, ContainerObj, ExtraLinkObj, Delay)
                // ここでは「左の矢印リンク」にマウスオーバーすると、「ボックス内の画像」が反応する仕組み
                const btn = new GNS.UIThumBtn(arrowLinkEl, null, boxImgObj, boxObj, internalLinkObj, 0.05 * index);
                this.buttons.push(btn);
            });
        }
    };

    /**
     * 表示ハンドラ
     */
    scene.showHandler = function () { };

    /**
     * 非表示ハンドラ
     */
    scene.hideHandler = function () { };

    /**
     * リセットハンドラ
     */
    scene.resetHandler = function () {
        this.buttons.forEach(btn => {
            if (btn.kill) btn.kill();
        });
        this.buttons = [];
    };

    return scene._self;
}(GNS);
